import { render, staticRenderFns } from "./FirmSpecificDocumentBasedata.vue?vue&type=template&id=4a91112a"
import script from "./FirmSpecificDocumentBasedata.vue?vue&type=script&lang=js"
export * from "./FirmSpecificDocumentBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports